export default __webpack_public_path__ + "static/media/aboutgan.45c26380.mp4";